import { Component } from 'react';
import getIn from 'immutable-less/transmute/getIn';
import { ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import * as ObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import { getActionMetadataConfigFromAction } from 'automation-ui-action-features/actions/ActionMetadataConfigUtils';
import { getEventAnchorFromContextMap } from 'automation-ui-action-features/actions/classic-anchored-delay/utils/getEventAnchorFromContextMap';
import Action from 'automation-ui-action-features/records/Action';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import ActionDetailComponents from 'automation-ui-action-features/actions/ActionDetailComponents';
import PreviewCard from 'automation-ui-canvas/components/test-flow/PreviewCard';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { jsx as _jsx } from "react/jsx-runtime";
class ActionPreview extends Component {
  // Note(bheng): This only seems to be used by the Email action
  getMessageLangSuffix(logEvent) {
    const {
      flowObjectTypeId
    } = this.props;
    const status = getIn(['executionState'], logEvent);
    const errorType = getIn(['errorType'], logEvent);
    const errorSubType = getIn(['errorSubType'], logEvent);
    return status === ExecutionStates.SUCCESS && flowObjectTypeId !== ObjectTypes.CONTACT_ID ? [status, 'associated'] : [status, errorType, errorSubType];
  }
  getActionOutputs() {
    const {
      getActionOutputsForTargetActionById,
      logEvent: {
        action
      }
    } = this.props;
    let actionOutputs = [];
    if (getActionOutputsForTargetActionById) {
      actionOutputs = getActionOutputsForTargetActionById(action.actionId);
    }
    return actionOutputs;
  }
  renderContent() {
    const {
      logEvent,
      flowObjectTypeId,
      flow,
      getHeaderTitle,
      actionLabel,
      getActionOutputsForTargetActionById
    } = this.props;
    const {
      action,
      objectId
    } = logEvent;
    const {
      actionType,
      metadata,
      connection
    } = action;
    const contextMap = getIn(['contextMap'], logEvent);
    const options = {
      objectName: objectId ? /*#__PURE__*/_jsx(ObjectNameReference, {
        id: objectId,
        objectTypeId: flowObjectTypeId
      }) : ''
    };
    const ActionDetailComponent = ActionDetailComponents[actionType];
    if (!ActionDetailComponent) {
      throw new Error(`Unrecognized action type: ${actionType}. Please add it to ActionPreview#renderContent.`);
    }
    const extraProps = {};
    if (actionType === ActionTypes.CLASSIC_ANCHORED_DELAY) {
      extraProps.eventAnchor = getEventAnchorFromContextMap({
        contextMap
      });
    }
    return /*#__PURE__*/_jsx(ActionDetailComponent, Object.assign({
      actionMetadata: metadata,
      flowObjectTypeId: flowObjectTypeId,
      flow: flow,
      connection: connection,
      flowId: flow && flow.getFlowId(),
      getHeaderTitle: getHeaderTitle,
      messageLangPath: "actionPreview",
      messageLangSuffix: this.getMessageLangSuffix(logEvent),
      options: options,
      getActionLabelById: () => actionLabel,
      actionOutputs: this.getActionOutputs(),
      actionId: action === null || action === void 0 ? void 0 : action.actionId,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    }, extraProps));
  }
  render() {
    const {
      logEvent: {
        action,
        timestamp
      },
      actionLabel,
      extensionDefinitions,
      renderContentOnly
    } = this.props;
    const actionDefinition = getActionMetadataConfigFromAction(new Action(action), undefined, extensionDefinitions);
    const {
      icon,
      theme
    } = actionDefinition;
    const content = this.renderContent();
    if (renderContentOnly) {
      return /*#__PURE__*/_jsx("div", {
        "data-test-id": "test-action-preview",
        className: "m-bottom-2",
        children: content
      });
    }
    return /*#__PURE__*/_jsx(PreviewCard, {
      theme: theme,
      icon: icon,
      header: actionLabel,
      content: content,
      timestamp: timestamp,
      "data-test-id": "test-action-preview"
    });
  }
}
export default wireAuthConsumer(ActionPreview);